import { Typography } from "antd";
import BirthDayStyle from "../assests/birthdayTemplate.png";
import TestImage from "../assests/TestImage.jpg";

const { Title, Paragraph, Text } = Typography;

export default function BirthDayTemplate({employee}) {
    const employeeName = employee?.id !== 34 ? employee?.user?.first_name : employee?.user?.last_name;
    const organizationName = employee?.organisation_name;
    const departmentName = employee?.department_name;
    const designation = employee?.designation_name;

    console.log("BirthDay Employee",employee)

    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    background: "transparent",
                }}
            >
                <div
                    style={{
                        position: "relative",
                        width: "400px",
                        height: "600px",
                        background: "white",
                        borderRadius: "10px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        overflow: "hidden",
                    }}
                >
                    {/* Background Birthday Template */}
                    <img
                        src={BirthDayStyle}
                        alt="Birthday Template"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            zIndex: 1,
                        }}
                    />

                    {/* Photo inside the frame */}
                    <img
                        src={`${employee?.photo}`}
                        alt="Employee"
                        style={{
                            position: "absolute",
                            top: "205px",
                            left: "98px",
                            width: "193px",
                            height: "190px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            zIndex: 2,
                            border: "2px solid white",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                        }}
                    />

                    {/* Employee Info */}
                    <div
                        style={{
                            position: "absolute",
                            top: "405px",
                            left: 0,
                            right: 0,
                            textAlign: "center",
                            zIndex: 3,
                            padding: "0 20px",
                            color: "#2e2e2e",
                        }}
                    >
                        <Title
                            level={4}
                            style={{
                                fontFamily: "Georgia, serif",
                                color: "#0e497b",
                                marginBottom: "14px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {employeeName}
                        </Title>

                        <Text
                            style={{
                                display: "block",
                                fontSize: "10px",
                                fontWeight: "500",
                                color: "#4a4a4a",
                                marginBottom: "2px",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {designation} - {departmentName}
                        </Text>

                        <Text
                            strong
                            style={{
                                display: "block",
                                fontSize: "10px",
                                color: "#0e497b",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {organizationName}
                        </Text>
                    </div>

                    {/* Birthday Wish Text */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: "50px",
                            left: "0",
                            right: "0",
                            textAlign: "center",
                            padding: "0 50px",
                            zIndex: 3,
                            color: "#5a3e36",
                        }}
                    >
                        <Paragraph
                            style={{
                                fontSize: "13px",
                                color: "#4a4a4a",
                                fontFamily: "Georgia, serif",
                                lineHeight: "1.4",
                            }}
                        >
                            Wishing you a day filled with happiness and joy!
                            <br />
                            <b> Warm wishes from the entire <br />
                                <span style={{ color: "#0e497b" }}>
                                    Baashyaam Group Family!
                                </span>
                            </b>
                        </Paragraph>
                    </div>
                </div>
            </div>
        </>
    );
}
